/**
 * Compact language selector. Writes through to LocaleContext so the change
 * is both persisted (localStorage) and propagated to i18next on the same
 * tick — no reload needed.
 */
import { Languages } from "lucide-react";
import { useTranslation } from "react-i18next";
import { SUPPORTED_LOCALES, type SupportedLocale } from "@/i18n";
import { useLocale } from "@/context/LocaleContext";

export function LanguageSwitcher() {
  const { locale, setLocale } = useLocale();
  const { t } = useTranslation();

  return (
    <label className="flex items-center gap-1.5 pl-2 pr-1 h-9 rounded-lg border border-border text-sm text-text-muted hover:text-text-primary hover:border-accent/50 transition-colors focus-within:ring-2 focus-within:ring-accent">
      <Languages className="h-4 w-4 shrink-0" aria-hidden="true" />
      <span className="sr-only">{t("common.language")}</span>
      <select
        aria-label={t("common.language")}
        value={locale}
        onChange={(e) => setLocale(e.target.value as SupportedLocale)}
        className="h-full bg-transparent text-text-primary text-sm focus:outline-none pr-1"
      >
        {SUPPORTED_LOCALES.map((l) => (
          <option key={l.code} value={l.code}>
            {l.label}
          </option>
        ))}
      </select>
    </label>
  );
}
